import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=0b353288"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports